import React, { useState } from "react";

const LogHistory = ({
  LogArray = [],
  logType = "comments",
  loadData = () => {},
  remindersArray = [],
}) => {
  return (
    <div className="px-3 flex flex-col col-span-2 pt-2 max-md:col-span-1">
      <span className="flex">
        <h1
          className={
            " font-semibold text-[18px] p-1 hover:bg-tertiary rounded-tl-lg border-t border-l border-r " +
            (logType == "comments" && " bg-tertiary ")
          }
          onClick={() => {
            loadData("comments");
          }}
        >
          Comments
        </h1>
        <h1
          className={
            " font-semibold text-[18px] p-1 hover:bg-tertiary border-t border-r " +
            (logType == "history" && " bg-tertiary ")
          }
          onClick={() => {
            loadData("history");
          }}
        >
          History
        </h1>
        <h1
          className={
            " font-semibold text-[18px] p-1 hover:bg-tertiary rounded-tr-lg border-t border-r " +
            (logType == "reminders" && " bg-tertiary ")
          }
          onClick={() => {
            loadData("reminders");
          }}
        >
          Reminders
        </h1>
      </span>
      <hr />
      <div className="min-h-[80px] max-h-[320px] overflow-y-auto">
        {logType === "reminders" ? (
          <>
            {remindersArray.map((rem, index) => (
              <div key={index} className="px-2 py-3 border-b border-gray-100 last:border-0">
                <div className="flex justify-between items-center mb-1">
                  <h4 className="text-sm font-bold text-blue-600">{rem.title}</h4>
                  <span className="text-[10px] text-gray-400">{rem.date} at {rem.time}</span>
                </div>
                <p className="text-xs text-gray-700">{rem.message}</p>
              </div>
            ))}
            {remindersArray.length === 0 && (
              <div className="text-gray-400 text-xs italic p-3">No reminders found for this task.</div>
            )}
          </>
        ) : (
          <>
            {LogArray.map((log, index) => (
              <React.Fragment key={index}>
                <HistoryCard logData={log} />
                {LogArray.length - 1 != index && <hr />}
              </React.Fragment>
            ))}
            {LogArray.length == 0 && (
              <div className="text-black p-3">No Log Found</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

function HistoryCard({ logData = {} }) {
  return (
    <>
      <div className="px-1 py-3">
        <h1>
          <b>{logData.User}</b>
          {` ${logData.Action} the `}
          <b>{logData.Field}</b>
          {` on ${logData.date} at ${logData.time}`}
        </h1>
        {((logData.old_data != "" && logData.old_data != undefined) ||
          (logData.new_data != "" && logData.new_data != undefined)) && (
          <div className="flex gap-5 items-center w-fit max-w-full pt-1 pl-4">
            <span className="w-fit max-w-[100%]">{logData.old_data}</span>
            <span className="w-fit max-w-[100%]">{" -> "}</span>
            <span className="w-fit max-w-[100%]">{logData.new_data}</span>
          </div>
        )}
      </div>
    </>
  );
}
export default LogHistory;
